import React, { useLayoutEffect, useRef, useState } from 'react';
import { ConfigTableLayoutBox } from './style';

/**
 * Flex-column layout for config pages that stack header + status tabs + table.
 * The table (a flex child) fills the remaining space and scrolls internally.
 *
 * The height is measured at runtime rather than derived from a percentage of an
 * ancestor: the Semantic-UI Sidebar.Pushable segment above these pages has no
 * height:100%, so a percentage-height chain collapses and the table grows
 * unbounded / gets clipped with no scrollbar. Measuring this element's distance
 * from the top of the viewport and filling to the bottom avoids both a broken
 * chain and a hard-coded offset.
 */
const ConfigTableLayout: React.FC = ({ children }) => {
  const ref = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState<string | undefined>(undefined);

  useLayoutEffect(() => {
    const updateHeight = () => {
      if (!ref.current) return;
      const top = ref.current.getBoundingClientRect().top;
      setHeight(`${Math.max(window.innerHeight - top, 0)}px`);
    };
    updateHeight();
    window.addEventListener('resize', updateHeight);
    return () => window.removeEventListener('resize', updateHeight);
  }, []);

  return (
    <ConfigTableLayoutBox ref={ref} style={{ height }}>
      {children}
    </ConfigTableLayoutBox>
  );
};

export default ConfigTableLayout;
